var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg50607032668386(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_28_",
    y: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJEKTS"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_122_"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M214.738,268.524h-98.04 c-12.715,0-23.023-10.308-23.023-23.023v-7.846c0-12.715,10.308-23.023,23.023-23.023h75.017 c12.715,0,23.023,10.308,23.023,23.023V268.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADDFFF"
    },
    d: "M317.063,408.724c27.563-9.721,54.231-26.343,71.684-50.567 c21.351-29.634,19.522-63.225,23.891-97.846c1.775-14.07,11.196-22.159,16.803-34.637c11.826-26.32,7.648-65.933-17.221-83.812 c-15.318-11.012-30.116-12.213-38.362-31.362c-4.56-10.589-7.227-22.245-14.308-31.342c-10.253-13.173-27.657-18.35-44.146-20.95 c-19.177-3.023-37.907-2.352-57.141-2.922c-20.502-0.608-41.295-0.054-61.198,5.389c-27.012,7.387-56.698,26.725-61.412,56.172 c-2.021,12.625,0.626,26.094-4.169,37.947c-7.215,17.834-26.436,23.883-40.75,34.419c-15.368,11.312-25.364,28.969-29.75,47.324 c-7.474,31.277-1.965,65.972,12.583,94.369c15.573,30.399,40.864,56.26,71.541,71.47c24.031,11.914,57.229,15.425,84.328,17.096 C259.049,421.297,289.197,418.551,317.063,408.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69A4C9"
    },
    d: "M387.597,286.614c-0.172-44.679-12.532-87.599-48.886-116.388 c-44.857-35.523-107.566-35.061-153.419-1.918c-29.985,21.673-51.013,54.284-62.804,89.353 c-11.791,35.069-14.833,72.582-13.577,109.559l272.996,0.854c1.141-12.549,2.282-25.098,3.422-37.647 C386.638,316.023,387.654,301.305,387.597,286.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M229.738,263.524h-98.04 c-12.715,0-23.023-10.308-23.023-23.023v-7.846c0-12.715,10.308-23.023,23.023-23.023h75.017 c12.715,0,23.023,10.308,23.023,23.023V263.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M328.628,174.657H193.492 c-16.818,0-30.451-13.633-30.451-30.451v-10.378c0-16.818,13.633-30.451,30.451-30.451h104.685 c16.818,0,30.451,13.633,30.451,30.451V174.657z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B1C99"
    },
    d: "M155.38,360.085c-0.336-0.346-0.779-0.566-1.157-0.865c-1.415-1.122-1.703-3.122-1.85-4.922 c-1.808-22.008,1.488-44.15,0.447-66.208c-0.249-5.264-4.521-2.677-8.009-2.004c-0.517,0.1-7.352,1.375-7.275,0.6 c-0.614,6.266-1.414,12.977-5.563,17.712c-2.874,3.28-6.981,5.152-10.588,7.602c-13.555,9.209-21.473,26.934-23.445,42.919 c-0.031-0.354-0.068-0.707-0.098-1.06c-0.265-3.187-0.478-6.379-0.637-9.573c-0.333-6.708-0.425-13.427-0.281-20.142 c0.107-4.999,0.713-10.467-2.298-14.805c-2.557-3.685-5.399-3.956-9.051-4.275c-0.978-1.993-0.812-5.922-0.8-7.692 c0.019-2.852,0.498-6.109,2.578-8.286c3.423-3.582,8.742-1.395,13.065-2.478c9.827-2.462,6.324-14.983,5.669-22.21 c-0.403-4.45-7.407-4.492-7,0c0.328,3.622,1.043,7.395,0.999,11.028c-0.028,2.332,0.034,3.839-2.45,4.561 c-0.996,0.289-2.362,0.005-3.379-0.004c-5.103-0.047-9.463,1.097-12.75,5.245c-3.55,4.48-4.09,10.264-3.5,15.768 c0.447,4.169,0.62,10.013,5.709,10.893c4.723,0.817,6.205,1.766,6.326,6.837c0.081,3.396-0.169,6.817-0.184,10.216 c-0.035,7.675,0.242,15.352,0.829,23.005c0.335,4.373-0.408,12.343,3.306,15.597c1.859,1.629,4.09,1.741,5.891,0.83 c5.821,0.319,19.585-0.505,21.061-0.505h17.758c2.979,0,8.223,1.015,11.065-0.447c1.547-0.796,4.299-2.25,5.413-3.555 C156.078,362.812,156.345,361.078,155.38,360.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8054F6"
    },
    d: "M153.003,294.529c0.026-1.798-0.022-3.597-0.144-5.389c-0.024-0.346-0.051-0.697-0.11-1.039 c-0.064-0.374-0.165-0.738-0.337-1.073c-1.29-2.516-5.885-0.338-7.695,0.548c-1.995,0.977-3.829,2.255-5.607,3.591 c-1.025,0.771-2.184,1.698-2.738,2.892c-0.589,1.268-0.248,3.306-0.124,4.666c0.094,1.031,0.267,2.106,0.896,2.921 c0.629,0.815,1.848,1.257,2.737,0.713c0.187,1.084,0.381,2.21,0.934,3.162c0.44,0.757,1.126,1.294,1.965,1.537 c0.564,0.164,0.534,0.063,0.733,0.651c0.006,0.017,0.013,0.033,0.018,0.05c0.121,0.457,0.3,0.901,0.536,1.298 c0.014,0.028,0.025,0.057,0.039,0.085c0.15,0.289,0.321,0.575,0.566,0.789c0.139,0.122,0.296,0.211,0.463,0.28 c0.006,0.004,0.012,0.007,0.017,0.01c0.003,0.001,0.006,0.003,0.009,0.005c0.328,0.206,0.696,0.341,1.104,0.374 c1.01,0.083,2.068-0.195,2.635-1.109c0.606-0.976,0.474-2.1,0.412-3.191c0.762-0.038,1.466-0.431,1.832-1.258 c0.373-0.844,0.288-1.911,0.302-2.8c0.017-1.077-0.034-2.149-0.116-3.22C153.437,299.244,152.981,295.974,153.003,294.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.3841,
    y1: 354.6646,
    x2: 151.9142,
    y2: 339.7729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19034D",
      stopOpacity: 0.9148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#311573",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M129.929,330.331c3.54,2.125,5.857,6.408,5.434,10.554 c-0.441,4.327-3.864,7.783-7.031,10.435c-3.314,2.776-6.996,5.342-9.12,9.108c2.173-0.275,4.359-0.443,6.548-0.503 c1.874-0.051,4.042,0.12,5.136,1.641c1.146,1.593,0.511,3.802,0.813,5.741c0.211,0.13,0.518,0.068,0.662-0.134 c0.144,0.503,0.1,0.534,0.622,0.495c1.75-0.131,3.235-1.449,4.043-3.007c0.808-1.558,1.055-3.337,1.264-5.08 c0.746-6.24,1.149-12.54,0.741-18.81c-0.129-1.983-0.362-4.034-1.382-5.74C135.956,332.183,133.25,330.064,129.929,330.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B1C99"
    },
    d: "M121.172,272.233c-0.086-0.313-0.174-0.626-0.266-0.938c0.044,0.15,0.846,0.448,1.002,0.532 c0.359,0.193,0.716,0.388,1.072,0.586c0.712,0.395,1.419,0.799,2.121,1.213c0.702,0.413,1.399,0.835,2.09,1.266 c0.311,0.194,0.472,0.367,0.829,0.313c0.505-0.078,1.024-0.392,1.499-0.578c0.604-0.236,1.204-0.48,1.807-0.719 c1.206-0.477,2.413-0.95,3.618-1.427c2.384-0.942,4.763-1.896,7.116-2.913c0.91-0.393,2.969-0.92,3.322-1.917 c0.126-0.356,0.129-0.742,0.149-1.119C145.632,264.618,146,261,146,261s1.43,1.22,1.655,1.487 c0.521,0.619,1.018,1.257,1.496,1.91c0.959,1.311,1.821,2.633,2.61,4.057c1.651,2.981,3.056,6.098,4.197,9.309 c0.918,2.584,1.379,5.167-0.348,7.501c-1.604,2.167-4.151,3.532-6.497,4.742c-4.769,2.461-9.885,5.218-15.301,5.733 c-1.356,0.129-2.785,0.097-3.997-0.525c-1.247-0.639-2.121-1.829-2.783-3.065C123.694,285.917,123.007,278.931,121.172,272.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M147.861,285.998c-1.577-0.522-3.241-0.631-4.828-1.085c0.107-0.166,0.2-0.345,0.286-0.495 c0.239-0.42,0.469-0.844,0.693-1.272c0.16-0.305,0.011-0.619-0.299-0.734c-0.523-0.196-1.397,0.284-1.89,0.457 c-0.767,0.27-1.509,0.593-2.206,1.012c-0.377,0.227-0.288,0.785,0.119,0.914c0.669,0.211,1.338,0.422,2.007,0.633 c-0.679,1.695-1.276,3.416-1.757,5.18c-0.17,0.622,0.795,0.887,0.964,0.266c0.467-1.711,1.045-3.381,1.699-5.027 c1.622,0.484,3.33,0.581,4.947,1.117C148.207,287.165,148.47,286.199,147.861,285.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M134.149,281.799c-0.235-0.083-0.453-0.074-0.643,0c-0.124-0.012-0.252,0.031-0.358,0.167 c-0.098,0.125-0.163,0.267-0.207,0.413c-0.033,0.076-0.061,0.155-0.08,0.238c-0.04,0.172,0.008,0.313,0.095,0.419 c0.053,0.136,0.132,0.264,0.257,0.374c0.444,0.388,1.131,0.227,1.434-0.255C134.965,282.646,134.704,281.995,134.149,281.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M149.149,275.799c-0.235-0.083-0.453-0.074-0.643,0c-0.124-0.012-0.252,0.031-0.358,0.167 c-0.098,0.125-0.163,0.267-0.207,0.413c-0.033,0.076-0.061,0.155-0.08,0.238c-0.04,0.172,0.008,0.313,0.095,0.419 c0.053,0.136,0.132,0.264,0.257,0.374c0.444,0.388,1.131,0.227,1.434-0.255C149.965,276.646,149.704,275.995,149.149,275.799z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M373.295,230.02h-71.067v-24.402 c0-13.477,10.925-24.402,24.402-24.402h46.665c13.477,0,24.402,10.925,24.402,24.402v0 C397.697,219.095,386.771,230.02,373.295,230.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M175.037,340.677c-1.901,6.525-3.539,14.087,0.312,19.687c4.638,6.744,15.284,6.667,21.969,1.945 c6.686-4.723,10.308-12.583,13.404-20.161c5.216-12.767,9.811-25.915,11.624-39.587c1.06-7.995,0.138-17.918-7.121-21.432 c-11.162-5.404-20.682,3.211-24.296,12.655C185.027,309.209,179.657,324.816,175.037,340.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5BA00"
    },
    d: "M208.922,258.236c-2.87,3.053-5.443,6.395-7.702,9.913c-3.145,4.899-5.261,10.139-7.729,15.366 c-0.865,1.832-8.126,17.758-6.504,18.917c9.127,6.524,18.094,13.651,28.549,17.66c0.353,0.135-1.643,7.798-1.827,8.531 c-0.712,2.834-1.356,5.684-1.934,8.549c-1.146,5.685-2.042,11.463-3.043,17.191c-0.557,3.19-1.101,6.382-1.631,9.576 c-0.238,1.43,45.204,4.458,49.318,4.519c12.021,0.177,30.913,3.551,38.211-8.721c1.73-2.909,2.595-6.24,3.365-9.536 c4.506-19.302,6.435-39.188,5.97-59.004c-0.109-4.65-0.355-9.334-1.485-13.846c-1.646-6.572-5.095-12.467-8.7-18.133 c-3.288-5.168-8.469-8.025-13.964-10.654c-16.545-7.917-36.458-10.464-53.242-3.068 C219.843,248.462,213.93,252.909,208.922,258.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M284.449,305.001c-0.454,1.048-0.907,2.097-1.361,3.145c-1.744,4.031-6.131,11.012-6.131,15.431 c-2.048,6.408-3.026,13.276-1.832,19.897c0.478,2.649,1.295,5.225,2.164,7.773c1.095,3.213,2.303,6.448,4.34,9.162 c1.834,2.443,6.21,6.298,9.597,4.981c3.534-1.375,6.173-7.79,7.522-10.958c8.017-18.834,11.193-39.523,13.147-59.782 c0.137-1.417,0.262-2.861-0.037-4.254c-0.446-2.076-1.786-3.83-3.115-5.486c-1.756-2.189-3.791-4.483-6.553-4.974 c-2.648-0.471-5.353,0.906-7.173,2.887c-1.819,1.981-2.92,4.5-3.988,6.968C288.836,294.862,286.642,299.931,284.449,305.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5BA00"
    },
    d: "M298.98,302.88c-1.545-0.434-23.099-5.668-23.148-3.014c0.16-11.705,0.807-23.403,1.94-35.054 c0.361-3.713,0.785-7.478,2.196-10.931c1.411-3.453,3.954-6.611,7.441-7.935c2.574-0.978,5.448-0.887,8.138-0.302 c8.472,1.841,15.62,8.785,17.706,17.2c0.894,3.607,0.915,7.367,0.88,11.083c-0.102,11.044-0.919,22.047-1.571,33.038 C307.93,306.863,303.404,304.124,298.98,302.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6352"
    },
    d: "M309.924,243.515c0.283,0.999,0.484,2.016,0.551,3.061c0.451,7.022-4.159,12.892-8.794,17.636 c-1.815,1.858-4.376,3.142-6.018,5.074c-1.875,2.206-1.789,5.846-5.047,6.829c-1.415,0.427-3.036-0.112-4.003-1.209 c-1.184-1.343-1.152-2.794-0.561-4.389c0.701-1.892,1.326-4.251,2.451-5.934c0.901-1.349,2.715-2.246,4.064-3.046 c2.733-1.62,4.873-4.72,5.322-7.848c0.848-5.91-0.01-12.575,2.047-18.222c0.356-0.977,0.836-1.942,1.615-2.632 c0.778-0.69,1.905-1.059,2.888-0.718c1.444,0.501,2.012,2.189,2.516,3.633C307.864,238.36,309.177,240.878,309.924,243.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6352"
    },
    d: "M302.219,317.78c0.672,12.63,0.516,25.497-2.918,37.76c-1.025,3.658-2.717,8.903-6.262,10.947 c-4,2.306-10.275,0.445-13.987-1.681c-2.452-1.404-4.8-3.132-6.35-5.495c-2.448-3.732-2.582-8.494-2.297-12.948 c0.767-11.968,3.736-23.134,6.052-34.8c2.525-12.718,5.48-25.349,8.861-37.867c1.445-5.348,3.306-9.327,7.775-12.696 c3.188-2.402,8.536-5.579,8.832,0.666C302.808,280.327,301.222,299.044,302.219,317.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M251.753,253.786c-0.387,0.67-0.729,1.363-0.893,2.115c-0.209,0.963-0.113,1.964,0.009,2.942 c0.915,7.303,2.437,14.53,10.27,16.813c5.195,1.514,11.606,0.982,16.36-1.678c1.525-0.853,3.03-1.791,4.23-3.061 c1.2-1.27,2.08-2.917,2.128-4.664c5.259,1.154,10.698-4.2,13.436-8.046c6.275-8.813,8.355-19.867,7.401-30.516 c-0.234-2.617-0.637-5.353-2.215-7.454c-1.102-1.466-2.679-2.488-4.224-3.477c-7.197-4.605-14.863-4.856-22.726-1.222 c-7.144,3.302-12.101,10.365-15.454,17.224c-1.402,2.869-1.649,6.651-2.773,9.722c-1.318,3.602-2.987,7.076-4.98,10.354 C252.132,253.153,251.937,253.467,251.753,253.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M261.686,216.772c1.633-3.616,3.981-6.962,6.951-9.023c5.405-3.751,13.226-3.051,19.311-1.688 c3.504,0.785,7.009,2.313,10.652,2.27c3.283-0.038,6.683-3.314,9.866-2.211c1.409,0.488,2.526,1.742,2.85,3.197 c0.532,2.393-0.954,4.704-2.106,6.869c-0.911,1.713-1.655,3.533-2.838,5.07c-1.549,2.014-3.975,3.676-6.545,3.972 c-0.862,0.099-1.734,0.009-2.597-0.081c-5.166-0.541-9.504-1.98-13.46,2.107c-2.69,2.779-4.032,6.583-6.01,9.842 c-0.482,0.794-1.028,1.59-1.822,2.073c-1.049,0.639-2.352,0.63-3.549,0.908c-5.129,1.189-8.503,9.786-13.923,7.937 c-4.646-1.585-3.588-5.805-1.753-9.147c2.284-4.157,1.849-9.203,2.538-13.896C259.63,222.374,260.456,219.496,261.686,216.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M262.97,236.641c-1.214,1.559-1.834,3.5-2.215,5.438c-0.328,1.668-0.49,3.423,0.017,5.045 s1.812,3.084,3.49,3.355c1.315,0.212,2.671-0.334,3.675-1.21c2.391-2.089,5.2-8.51,4.517-11.784 C271.477,232.795,265.327,233.613,262.97,236.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M267.701,238.362c-1.337,0.454-2.348,1.603-2.951,2.88 c-0.604,1.277-0.854,2.687-1.099,4.078"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M301.647,239.335c0.145,0.63-0.248,1.258-0.878,1.403c-0.63,0.145-1.258-0.248-1.403-0.878 c-0.145-0.63,0.248-1.258,0.878-1.403C300.874,238.312,301.502,238.705,301.647,239.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M288.521,240.35c0.106,0.638-0.325,1.24-0.963,1.346c-0.638,0.106-1.241-0.325-1.346-0.963 c-0.106-0.638,0.325-1.24,0.962-1.347C287.812,239.281,288.415,239.712,288.521,240.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031912461376917373690000012944363564078358151_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.649,
    y1: 370.1591,
    x2: 288.863,
    y2: 339.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.9148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031912461376917373690000012944363564078358151_)"
    },
    d: "M271.529,336.535 c-0.512,3.259-0.912,6.533-1.123,9.827c-0.286,4.454-0.151,9.217,2.297,12.948c1.55,2.362,3.898,4.09,6.35,5.495 c3.712,2.126,9.987,3.987,13.987,1.681c3.544-2.044,5.237-7.288,6.262-10.947c1.741-6.216,2.637-12.588,3.012-19.004H271.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030447614702628637590000001336019179939295121_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.5448,
    y1: 314.3124,
    x2: 231.4604,
    y2: 330.5774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.9148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030447614702628637590000001336019179939295121_)"
    },
    d: "M235.613,317.129 c-1.822-5.194-3.644-10.388-5.466-15.582c0.135,0.385-0.977,2.122-1.165,2.534c-0.41,0.899-0.818,1.798-1.226,2.698 c-0.84,1.852-1.68,3.703-2.541,5.546c-1.629,3.486-3.235,7.092-5.243,10.359c-1.587-0.526-3.081-1.331-4.394-2.366 c-0.543,3.162-1.53,6.121-2.163,9.265c-0.328,1.628-0.625,3.261-0.926,4.894c-0.153,0.829-0.306,1.658-0.464,2.486 c-0.064,0.336-0.187,2.109-0.45,2.263c8.524-4.986,16.342-11.178,23.147-18.335c0.545-0.573,1.109-1.205,1.215-1.988 C236.018,318.3,235.814,317.701,235.613,317.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M302.465,232.956c-1.594-0.221-3.249,0.161-4.583,1.061c-0.63,0.425-0.956,1.192-0.57,1.909 c0.334,0.619,1.275,0.997,1.909,0.57c0.975-0.658,1.96-0.887,3.124-0.725c0.753,0.105,1.438-0.639,1.467-1.347 C303.847,233.602,303.222,233.061,302.465,232.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M291.105,235.168c-1.957-0.902-4.054-0.504-6.051,0.041c-1.535,0.419-1.164,2.898,0.392,2.473 c1.554-0.424,3.193-0.897,4.729-0.189C291.641,238.168,292.564,235.84,291.105,235.168z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139271967054670202980000002316427275290300857_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.9413,
    y1: 236.6636,
    x2: 255.247,
    y2: 250.3626,
    gradientTransform: "matrix(0.9745 -0.2244 0.2244 0.9745 -31.9478 88.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.9148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139271967054670202980000002316427275290300857_)"
    },
    d: "M273.473,261.881 c-0.116,2.613-0.217,5.227-0.29,7.842c-0.038,1.362-0.07,2.724-0.093,4.087c-0.004,0.248-0.067,0.712-0.086,1.192 c1.587-0.393,3.225-0.664,4.726-1.349c2.13-0.972,4.187-2.294,5.26-4.47c0.412-0.834,0.664-1.734,0.908-2.638 C280.308,265.811,276.176,264.439,273.473,261.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M245.968,367.84c13.542,1.615,28.471,3.371,41.496-0.472c-2.114-3.012-4.249-6.049-6.941-8.559 c-2.692-2.51-6.018-4.485-9.67-4.944c-1.925-0.242-3.877-0.058-5.802,0.177c-3.371,0.411-7.745,2.163-11.065,1.891 c-2.824-0.232-6.507-2.651-9.179-3.709c-18.131-7.175-39.637-16.943-59.456-11.731c-10.024,2.636-16.052,11.005-9.143,20.432 c3.859,5.265,10.102,4.283,16.185,4.384c16.421,0.275,32.896,0.142,49.237,2.019C243.057,367.492,244.504,367.665,245.968,367.84 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19034D"
    },
    d: "M286.867,255.778l-0.969-0.25c0.553-2.133,1.27-3.72,2.257-4.994 c1.263-1.628,3.001-2.673,4.768-2.867c0.635-0.069,1.212-0.023,1.721,0.136c1.04,0.325,1.959,1.194,2.521,2.384l-0.904,0.427 c-0.442-0.938-1.141-1.615-1.915-1.857c-0.377-0.118-0.818-0.15-1.313-0.096c-1.5,0.164-2.99,1.07-4.087,2.486 C288.045,252.311,287.384,253.782,286.867,255.778z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093150104537080301520000009768055608000071347_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.4091,
    y1: 347.5295,
    x2: 200.7093,
    y2: 329.8662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.9148
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093150104537080301520000009768055608000071347_)"
    },
    d: "M212.019,334.537 c-0.136-0.228-0.269-0.457-0.401-0.688c-0.943-1.546-1.83-3.127-2.676-4.731c-1.257,1.24-2.476,2.447-3.95,3.458 c-1.893,1.298-3.592,2.859-5.183,4.508c-0.975,1.011-1.911,2.058-2.838,3.113c0.246,0.569,0.485,1.144,0.721,1.727 c0.117,0.287,0.245,0.57,0.369,0.854c0.628-0.212,1.261-0.412,1.9-0.597c3.222-0.934,7.463-2.209,11.037-1.698 c0.189-1.954,0.951-3.812,1.107-5.765C212.075,334.658,212.047,334.597,212.019,334.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6352"
    },
    d: "M290.855,259.771c-0.581-0.005-1.411,0.372-1.687,0.906c-0.15,0.29-0.089,0.599,0.088,0.782 c0.039,0.187,0.158,0.354,0.398,0.415c0.709,0.182,1.346-0.184,1.778-0.739C291.873,260.568,291.641,259.778,290.855,259.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6352"
    },
    d: "M291.87,232.219c-0.724-0.3-1.466-0.475-2.243-0.565c-0.638-0.074-0.633,0.927,0,1 c0.684,0.079,1.342,0.266,1.978,0.529C292.198,233.429,292.457,232.462,291.87,232.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6352"
    },
    d: "M298.085,230.77c-0.525,0.162-1.049,0.325-1.574,0.487c-0.613,0.19-0.351,1.155,0.266,0.964 c0.525-0.162,1.049-0.325,1.574-0.487C298.963,231.544,298.702,230.579,298.085,230.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8054F6"
    },
    d: "M318.628,162.657H183.492c-16.818,0-30.451-13.633-30.451-30.451v-10.378 c0-16.818,13.633-30.451,30.451-30.451h104.685c16.818,0,30.451,13.633,30.451,30.451V162.657z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.372,133.751h-3.053v5.366h-7.395v-5.366h-11.054v-5.499l11.528-16.855h6.92v16.761h3.053 V133.751z M202.924,128.157v-3.223c0-0.607,0.022-1.425,0.066-2.456c0.044-1.03,0.079-1.57,0.105-1.621h-0.209 c-0.43,0.974-0.917,1.884-1.46,2.73l-3.072,4.569H202.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.112,125.294c0,4.904-0.822,8.497-2.465,10.779c-1.644,2.282-4.159,3.422-7.546,3.422 c-3.311,0-5.808-1.191-7.489-3.574c-1.681-2.382-2.521-5.925-2.521-10.627c0-4.93,0.821-8.545,2.465-10.845 c1.643-2.301,4.158-3.451,7.546-3.451c3.299,0,5.793,1.198,7.48,3.593C242.269,116.987,243.112,120.554,243.112,125.294z  M230.541,125.294c0,3.135,0.196,5.29,0.588,6.465c0.392,1.175,1.049,1.763,1.972,1.763c0.936,0,1.596-0.607,1.981-1.82 c0.385-1.213,0.578-3.349,0.578-6.408c0-3.072-0.196-5.224-0.587-6.456c-0.392-1.232-1.049-1.849-1.972-1.849 c-0.923,0-1.58,0.594-1.972,1.782C230.737,119.96,230.541,122.134,230.541,125.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.407,133.751h-3.052v5.366h-7.395v-5.366h-11.054v-5.499l11.527-16.855h6.921v16.761h3.052 V133.751z M263.961,128.157v-3.223c0-0.607,0.021-1.425,0.066-2.456c0.044-1.03,0.078-1.57,0.104-1.621h-0.208 c-0.43,0.974-0.917,1.884-1.46,2.73l-3.071,4.569H263.961z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.738,233.524h-98.04c-12.715,0-23.023-10.308-23.023-23.023v-7.846 c0-12.715,10.308-23.023,23.023-23.023h75.017c12.715,0,23.023,10.308,23.023,23.023V233.524z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M158.794,212.464c-1.662,0-2.96-0.458-3.896-1.376c-0.936-0.917-1.403-2.215-1.403-3.895 c0-1.729,0.433-3.066,1.297-4.011c0.865-0.944,2.06-1.417,3.586-1.417c1.458,0,2.594,0.416,3.406,1.247 c0.812,0.831,1.218,1.979,1.218,3.443v1.366h-6.655c0.031,0.8,0.267,1.425,0.711,1.874c0.443,0.449,1.064,0.674,1.864,0.674 c0.622,0,1.209-0.065,1.763-0.194c0.554-0.129,1.132-0.335,1.735-0.619v2.179c-0.492,0.246-1.019,0.429-1.579,0.549 C160.283,212.404,159.6,212.464,158.794,212.464z M158.397,203.769c-0.597,0-1.065,0.189-1.403,0.567 c-0.338,0.379-0.532,0.916-0.582,1.611h3.951c-0.012-0.695-0.194-1.232-0.544-1.611 C159.468,203.958,158.994,203.769,158.397,203.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M172.943,201.765c0.382,0,0.699,0.028,0.951,0.083l-0.212,2.64 c-0.228-0.061-0.505-0.092-0.831-0.092c-0.898,0-1.598,0.231-2.1,0.692c-0.501,0.461-0.752,1.108-0.752,1.939v5.252h-2.815 v-10.32h2.132l0.416,1.736h0.138c0.32-0.579,0.753-1.045,1.297-1.399C171.711,201.942,172.303,201.765,172.943,201.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M183.418,201.765c0.382,0,0.699,0.028,0.951,0.083l-0.212,2.64 c-0.228-0.061-0.505-0.092-0.831-0.092c-0.898,0-1.598,0.231-2.1,0.692c-0.502,0.461-0.752,1.108-0.752,1.939v5.252h-2.815 v-10.32h2.132l0.416,1.736h0.138c0.32-0.579,0.753-1.045,1.297-1.399C182.186,201.942,182.778,201.765,183.418,201.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M197.512,207.101c0,1.68-0.443,2.994-1.329,3.942c-0.886,0.948-2.12,1.421-3.702,1.421 c-0.991,0-1.865-0.217-2.622-0.651c-0.757-0.434-1.338-1.057-1.745-1.869c-0.406-0.813-0.609-1.76-0.609-2.843 c0-1.686,0.44-2.997,1.32-3.932c0.88-0.936,2.117-1.403,3.71-1.403c0.991,0,1.865,0.216,2.622,0.646 c0.757,0.431,1.339,1.049,1.745,1.855C197.309,205.073,197.512,206.018,197.512,207.101z M190.376,207.101 c0,1.022,0.167,1.794,0.503,2.317c0.335,0.523,0.881,0.784,1.639,0.784c0.751,0,1.29-0.26,1.62-0.78 c0.329-0.52,0.494-1.294,0.494-2.322c0-1.021-0.166-1.788-0.498-2.298c-0.333-0.511-0.877-0.766-1.634-0.766 c-0.751,0-1.292,0.254-1.624,0.762C190.542,205.305,190.376,206.073,190.376,207.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF735F"
    },
    d: "M207.488,201.765c0.382,0,0.699,0.028,0.951,0.083l-0.212,2.64 c-0.228-0.061-0.505-0.092-0.831-0.092c-0.898,0-1.598,0.231-2.1,0.692c-0.502,0.461-0.752,1.108-0.752,1.939v5.252h-2.815 v-10.32h2.132l0.416,1.736h0.138c0.32-0.579,0.752-1.045,1.297-1.399C206.256,201.942,206.848,201.765,207.488,201.765z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084502491500930776760000004015418699617357958_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.3532,
    y1: 303.9766,
    x2: 262.7509,
    y2: 222.8682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0045,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.49,
      fill: "url(#SVGID_00000084502491500930776760000004015418699617357958_)"
    },
    d: "M354.045,343.571 l-25.899-96.638c-3.642-13.589-15.817-23.143-29.883-23.449h0c-26.71-0.581-42.077,30.146-25.594,51.171 c27.079,34.541,57.02,73.345,57.02,73.345L354.045,343.571z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B1C99"
    },
    d: "M391.525,213.408h-71.297v-25.318c0-10.429,8.454-18.883,18.883-18.883h52.414 c10.429,0,18.883,8.454,18.883,18.883v6.435C410.408,204.954,401.954,213.408,391.525,213.408z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 351.959,
    cy: 191.307,
    r: 2.323
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M367.641,191.307c0,1.283-1.04,2.323-2.323,2.323c-1.283,0-2.323-1.04-2.323-2.323 s1.04-2.323,2.323-2.323C366.601,188.984,367.641,190.024,367.641,191.307z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 378.677,
    cy: 191.307,
    r: 2.323
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF0A40"
    },
    d: "M185.798,354.887c-1.379,0-2.694-0.135-3.84-0.375l0.439-2.096 c4.374,0.915,11.512-0.03,13.536-4.196c0.622-1.28,0.611-2.863-0.03-4.133c-0.654-1.295-1.703-2.169-3.12-2.6 c-2.713-0.827-6.241,0.109-8.532,1.4l-1.052-1.866c2.491-1.406,6.659-2.661,10.208-1.584c1.97,0.599,3.495,1.873,4.409,3.685 c0.935,1.853,0.952,4.164,0.044,6.033C195.822,353.352,190.449,354.887,185.798,354.887z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF0A40"
    },
    d: "M175.65,362.086h-7.423c-7.561,0-13.691-6.13-13.691-13.691v-14.153h34.805v14.153 C189.341,355.957,183.211,362.086,175.65,362.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.979,364.228h-53.545c-0.887,0-1.606-0.719-1.606-1.606l0,0c0-0.887,0.719-1.606,1.606-1.606 h53.545c0.887,0,1.606,0.719,1.606,1.606l0,0C200.585,363.509,199.866,364.228,198.979,364.228z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005988037826288174140000005507828028551518103_",
    d: "M401.106,328.294 c0.272-1.929,0.934-3.656,2.451-4.543c2.165-1.266,5.051-0.209,7.57-0.68c7.074-1.323,7.02-11.198,6.875-16.636 c-0.092-3.46-0.247-6.918-0.465-10.373c-0.058-0.915-0.132-1.87-0.607-2.654c-0.857-1.413-2.815-1.826-4.405-1.372 c-3.096,0.885-4.834,4.229-5.383,7.402c-0.549,3.172-0.28,6.471-1.112,9.582c-0.156,0.583-0.354,1.164-0.688,1.668 c-0.38,0.572-0.928,1.027-1.548,1.322c-0.904,0.43-2.033,0.5-2.876-0.041c-0.977-0.626-0.814-1.416-0.809-2.368 c0.007-1.136-0.158-2.308-0.292-3.467c-0.3-2.6-0.56-5.205-0.805-7.812c-0.481-5.123-0.898-10.252-1.432-15.37 c-0.245-2.348-0.51-4.76-1.682-6.863c-5.068-9.097-12.788-1.105-13.497,5.528c-1.614,15.092,6.247,29.324,5.588,44.303 c-0.028,0.631-0.06,1.281-0.348,1.855c-1.183,2.358-4.964,1.946-6.712,0.585c-2.74-2.133-1.758-6.751-1.762-9.53 c-0.003-2.268-0.729-4.831-2.922-5.893c-2.488-1.205-5.734,0.24-7.152,2.463c-1.829,2.869-1.626,7.783-1.352,10.976 c0.198,2.307,0.747,4.645,2.101,6.601c1.354,1.956,3.616,3.485,6.144,3.638c1.463,0.089,3.132-0.222,4.242,0.654 c1.352,1.067,0.867,3.019,0.92,4.651c0.106,3.24,2.867,6.008,6.087,7.369c3.22,1.362,6.855,1.591,10.396,1.799 c3.003-4.818,3.204-10.373,3.36-15.758C401.043,333.536,400.759,330.751,401.106,328.294z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096750823231131192020000005576173602370816698_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005988037826288174140000005507828028551518103_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096750823231131192020000005576173602370816698_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#228F4E"
    },
    d: "M401.106,328.294c0.272-1.929,0.934-3.656,2.451-4.543c2.165-1.266,5.051-0.209,7.57-0.68 c7.074-1.323,7.02-11.198,6.875-16.636c-0.092-3.46-0.247-6.918-0.465-10.373c-0.058-0.915-0.132-1.87-0.607-2.654 c-0.857-1.413-2.815-1.826-4.405-1.372c-3.096,0.885-4.834,4.229-5.383,7.402c-0.549,3.172-0.28,6.471-1.112,9.582 c-0.156,0.583-0.354,1.164-0.688,1.668c-0.38,0.572-0.928,1.027-1.548,1.322c-0.904,0.43-2.033,0.5-2.876-0.041 c-0.977-0.626-0.814-1.416-0.809-2.368c0.007-1.136-0.158-2.308-0.292-3.467c-0.3-2.6-0.56-5.205-0.805-7.812 c-0.481-5.123-0.898-10.252-1.432-15.37c-0.245-2.348-0.51-4.76-1.682-6.863c-5.068-9.097-12.788-1.105-13.497,5.528 c-1.614,15.092,6.247,29.324,5.588,44.303c-0.028,0.631-0.06,1.281-0.348,1.855c-1.183,2.358-4.964,1.946-6.712,0.585 c-2.74-2.133-1.758-6.751-1.762-9.53c-0.003-2.268-0.729-4.831-2.922-5.893c-2.488-1.205-5.734,0.24-7.152,2.463 c-1.829,2.869-1.626,7.783-1.352,10.976c0.198,2.307,0.747,4.645,2.101,6.601c1.354,1.956,3.616,3.485,6.144,3.638 c1.463,0.089,3.132-0.222,4.242,0.654c1.352,1.067,0.867,3.019,0.92,4.651c0.106,3.24,2.867,6.008,6.087,7.369 c3.22,1.362,6.855,1.591,10.396,1.799c3.003-4.818,3.204-10.373,3.36-15.758C401.043,333.536,400.759,330.751,401.106,328.294 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M391.574,272.546c3.606,25.029,6.715,50.507,2.275,75.424"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M388.111,272.377c-1.018,4.661-2.041,9.361-2.018,14.115 c0.044,9.062,3.862,17.729,5.362,26.687c1.675,10.007,0.434,20.208-0.809,30.268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M395.931,316.558c4.357-0.623,9.562-1.252,12.316-4.743 c0.393-0.498,0.735-1.039,0.917-1.63c0.729-2.369,0.365-5.052,0.354-7.486c-0.01-2.333,0.044-6.426,0.044-9.453"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M391.997,333.182c-3.915,0.638-8.247,1.209-11.623-0.712 c-2.066-1.176-3.466-3.165-4.207-5.283c-0.742-2.118-0.881-4.372-0.867-6.595c0.015-2.422,0.206-4.845,0.619-7.238"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#19034D",
      strokeMiterlimit: 10
    },
    d: "M395.979,320.56c4.976-0.74,9.859-2.001,14.522-3.751 c0.983-0.369,1.987-0.779,2.706-1.494c0.771-0.766,1.13-1.798,1.434-2.801c0.685-2.263,0.974-17.755,0.217-21.539"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5BA00"
    },
    points: "377.426,342.789 406.747,342.165 403.76,364 381.382,363.993  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.967,365.443H246.223c-1.381,0-2.5-1.119-2.5-2.5v-0.852c0-1.381,1.119-2.5,2.5-2.5h123.744 c1.381,0,2.5,1.119,2.5,2.5v0.852C372.467,364.323,371.347,365.443,369.967,365.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.868,365.443H262.851l9.572-63.218c0.332-2.195,2.196-3.833,4.36-3.833h101.297 c2.615,0,4.583,2.358,4.182,5.009L372.868,365.443z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#8054F6",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 327.895,
    cy: 327.405,
    r: 5.267
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M333.341,293.497 c-0.66-2.891-0.986-5.859-0.968-8.824c0.017-2.903,0.446-5.002,2.354-7.191c1.303-1.495,3.147-3.389,4.698-4.625 c4.365-3.481,6.054-9.943,3.95-15.114"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M342.568,284.996 c-0.583-2.483,0.795-5.025,2.531-6.894c1.737-1.868,3.878-3.363,5.389-5.418c3.24-4.407,3.085-8.55,2.492-16.728 c-0.417-5.751-0.307-12.271,3.842-16.276"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8054F6"
    },
    d: "M409.26,370.295H89.89c-1.657,0-3-1.343-3-3v-1.022c0-1.657,1.343-3,3-3H409.26 c1.657,0,3,1.343,3,3v1.022C412.26,368.952,410.917,370.295,409.26,370.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ADDFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M441.962,181.697 c2.469,15.674,3.481,32.505-3.7,46.655c-4.005,7.892-10.315,14.429-13.894,22.554c-3.819,8.671-5.168,17.674-6.116,27.073"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ADDFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M118.29,155.458 c-9.992,12.065-24.831,18.905-36.829,28.978c-19.401,16.289-30.9,41.591-30.411,66.919"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ADDFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M337.26,55.352 c16.279,5.146,30.155,17.445,37.219,32.988"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ADDFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M109.686,389.788 c22.031,19.356,50.58,31.158,79.847,33.008"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#69A4C9",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M329.11,395.578 c5.361-2.403,10.602-5.076,15.682-8.028"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#69A4C9",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M256.13,410.294 c21.269-0.936,39.732-1.949,62.663-11.026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50607032668386);
export default __webpack_public_path__ + "static/media/5060703_2668386.4028a45c1286f1af6cab5a8291622349.svg";
export { ForwardRef as ReactComponent };